module.exports = __webpack_public_path__ + "img/arrow-right-small.22e8d5ba.svg";